import ViewPanel from './ViewPanel';
import Template from '../classes/Template';

export default class MainViewPanel extends ViewPanel {
  mainPanelHeader: ?HTMLElement;
  mainPanelFooter: ?HTMLElement;
  mainPanel: ?HTMLElement;
  mainPanelActiveClass: string = ['overflow-y-scroll'];
  subPanelActiveClass: string = ['invisible', 'overflow-hidden'];

  /**
   * @inheritDoc
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.mainPanelHeader = this.el.querySelector('header');
    this.mainPanelFooter = this.el.querySelector('footer');
    this.mainPanel = this.el.getElementByRef('main-panel');
  }

  /**
   * @inheritDoc
   */
  toggle({ id }: { id: string }): void {
    this.mainPanel.scrollTo(0, 0);
    super.toggle({ id });

    setTimeout(() => {
      if (!window.store.activeViewPanels.contains(this.id)) return;

      const header: ?HTMLElement = this.el.querySelector('header');
      const footer: ?HTMLElement = this.el.querySelector('footer');

      if (window.store.activeViewPanels.count() > 1) {
        const latestViewPanelId = window.store.activeViewPanels.all()[window.store.activeViewPanels.all().length - 1];
        const subPanel = this.el.querySelector(`[data-component="view-panel"][data-id="${latestViewPanelId}"]`);
        this.setSubHeader(subPanel, header);
        this.setSubFooter(subPanel, footer);

        this.mainPanel.classList.add(...this.subPanelActiveClass);
        this.mainPanel.classList.remove(...this.mainPanelActiveClass);
      } else {
        this.setMainHeader(header);
        this.setMainFooter(footer);

        this.mainPanel.classList.add(...this.mainPanelActiveClass);
        this.mainPanel.classList.remove(...this.subPanelActiveClass);
      }
    }, 0);
  }

  /**
   * appends the main view panel header
   */
  setMainHeader(header: HTMLElement):void {
    if (this.mainPanelHeader) {
      this.el.removeChild(header);
      this.el.insertBefore(this.mainPanelHeader, this.el.firstChild);
    }
  }

  /**
   * appends the subview panel header
   */
  setSubHeader(subPanel: HTMLElement, header: HTMLElement) : void {
    const headerTemplate = subPanel.getElementByRef('header');
    if (headerTemplate) {
      const subHeader = Template.getContent(headerTemplate);
      header.parentElement.removeChild(header);
      this.el.insertBefore(subHeader, this.el.firstChild);
    }
  }

  /**
   * appends the main view panel footer
   */
  setMainFooter(footer: HTMLElement):void {
    if (this.mainPanelFooter) {
      this.el.removeChild(footer);
      this.el.appendChild(this.mainPanelFooter);
    }
  }

  /**
   * appends the subview panel footer
   */
  setSubFooter(subPanel, footer): void {
    const footerTemplate = subPanel.getElementByRef('footer');
    if (footerTemplate) {
      const subFooter = Template.getContent(footerTemplate);
      footer.parentElement.removeChild(footer);
      this.el.appendChild(subFooter);
    }
  }
}
